/* ============================================================
   ms-collection.js  -  Msofas collection page (hướng C)

   Hợp đồng HYBRID:
     • Facet native -> vẫn là form GET, nhưng JS gọi Section Rendering API
                       (?section_id=) rồi thay band/rail/lưới tại chỗ. Lỗi mạng
                       thì rơi về điều hướng thường; không JS thì form vẫn chạy.
     • Thước đo     -> lọc + phân trang hoàn toàn client-side, KHÔNG reload.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-ms-coll]');
  if (!root) return;

  var paintRule = null;
  window.addEventListener('resize', function () { if (paintRule) paintRule(); });

  function scrollToGrid() {
    var grid = root.querySelector('[data-ms-grid]');
    if (!grid) return;
    // Chua cho thanh thong bao dinh cung + thanh loc, thay vi hang so 80.
    var barH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ms-bar-h'), 10) || 0;
    var railEl = root.querySelector('.msc-rail');
    var railH = railEl ? railEl.getBoundingClientRect().height : 0;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - barH - railH - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* Mọi thứ trong vùng bị thay khi lọc ajax -> chạy lại sau mỗi lần thay. */
  function initContent() {
  paintRule = null;
  var grid = root.querySelector('[data-ms-grid]');
  // [data-ms-card] chứ không phải '.sc': app promo-tile chèn thẻ vào lưới và mượn
  // luôn class của card đầu tiên, bắt theo class là đếm cả tile của nó.
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-ms-card]')) : [];
  var slider = root.querySelector('[data-ms-wall]');
  var readout = root.querySelector('[data-ms-readout]');
  var readoutV = root.querySelector('[data-ms-readout-v]');
  var datum = root.querySelector('[data-ms-datum]');
  var fill = root.querySelector('[data-ms-fill]');
  var countEl = root.querySelector('[data-ms-count]');
  var total = countEl ? countEl.textContent : '';
  var suffixEl = root.querySelector('[data-ms-count-suffix]');
  var emptyEl = root.querySelector('[data-ms-empty]');
  var pager = root.querySelector('[data-ms-pager]');
  var tiles = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-ms-tile]')) : [];
  var fitWrap = root.querySelector('[data-ms-fit]');
  var fitRows = [];
  var perPage = parseInt(root.dataset.perPage, 10) || 12;

  /* ── thước ────────────────────────────────────────────── */
  // Chưa kéo thì không lọc gì cả: sp thiếu số đo vẫn hiện, vì ta chưa
  // được hỏi "có vừa không". Kéo rồi mới ẩn chúng — nói thật là không biết.
  var touched = false;
  var page = 1;

  function wall() {
    return slider ? parseInt(slider.value, 10) : 0;
  }

  function matching() {
    if (!touched) return cards;
    var w = wall();
    return cards.filter(function (c) {
      var cw = parseInt(c.dataset.w, 10);
      return cw > 0 && cw <= w;
    });
  }

  function render() {
    var list = matching();
    var pages = Math.max(1, Math.ceil(list.length / perPage));
    if (page > pages) page = pages;

    var start = (page - 1) * perPage;
    var slice = list.slice(start, start + perPage);
    cards.forEach(function (c) { c.hidden = true; });
    slice.forEach(function (c) { c.hidden = false; });
    placeTiles(slice, start);

    // Chua keo thuoc thi giu so cua server: >250 sp thi DOM chi co 1 trang, dem card la dem sai.
    if (countEl) countEl.textContent = touched ? list.length : total;
    if (suffixEl) suffixEl.textContent = touched ? ' that fit a ' + wall() + 'cm wall' : '';
    if (emptyEl) emptyEl.hidden = list.length > 0;
    paintFit();
    buildPager(pages);
  }

  // Tile la O TUYET DOI trong tap da loc, khong phai o cua tung trang: slot 5 chi
  // hien o trang chua o thu 5. Loc thay doi -> tile tu doi trang, hoac bien mat.
  function placeTiles(slice, start) {
    tiles.forEach(function (t) {
      var at = parseInt(t.dataset.msTile, 10);
      var local = at - start;
      if (!at || local < 1 || local > slice.length + 1) { t.hidden = true; return; }
      t.hidden = false;
      grid.insertBefore(t, slice[local - 1] || null);
    });
  }

  // Cac nhom lay tu chinh collection, khong hardcode 2/3 seater: collection corner
  // sofa bed thi ra "Corner Sofa Bed", collection tron thi ra du cac loai co mat.
  function buildFitRows() {
    if (!fitWrap) return;
    var counts = {};
    cards.forEach(function (c) {
      var k = c.dataset.seats;
      if (k) counts[k] = (counts[k] || 0) + 1;
    });
    // ponytail: >=3 sp de loai nhom le, toi da 4 dong cho vua cot band.
    var keys = Object.keys(counts)
      .filter(function (k) { return counts[k] >= 3; })
      .sort(function (a, b) { return counts[b] - counts[a]; })
      .slice(0, 4);

    fitWrap.innerHTML = '';
    keys.forEach(function (k) {
      var row = document.createElement('div');
      row.className = 'msc-fitrow';
      row.setAttribute('data-ms-fitrow', k);
      var dt = document.createElement('dt');
      dt.textContent = k;
      var dd = document.createElement('dd');
      dd.className = 'num';
      dd.textContent = '—';
      row.appendChild(dt);
      row.appendChild(dd);
      fitWrap.appendChild(row);
    });
    fitRows = Array.prototype.slice.call(fitWrap.querySelectorAll('[data-ms-fitrow]'));
  }

  // "Corner Sofa Bed 28 of 35 fit" — doc thang tu cac card, khong phai so uoc luong.
  function paintFit() {
    fitRows.forEach(function (row) {
      var group = cards.filter(function (c) { return c.dataset.seats === row.dataset.msFitrow; });
      var dd = row.querySelector('dd');
      if (!group.length) { row.hidden = true; return; }
      if (!touched) {
        dd.textContent = group.length;
        row.classList.remove('is-none');
        return;
      }
      var w = wall();
      var fit = group.filter(function (c) {
        var cw = parseInt(c.dataset.w, 10);
        return cw > 0 && cw <= w;
      }).length;
      dd.textContent = fit + ' of ' + group.length + ' fit';
      row.classList.toggle('is-none', fit === 0);
    });
  }

  function buildPager(pages) {
    if (!pager) return;
    if (pages < 2) { pager.hidden = true; pager.innerHTML = ''; return; }
    pager.hidden = false;
    pager.innerHTML = '';

    var add = function (label, target, current, aria) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      if (aria) b.setAttribute('aria-label', aria);
      if (current) b.setAttribute('aria-current', 'page');
      b.addEventListener('click', function () {
        page = target;
        render();
        scrollToGrid();
      });
      pager.appendChild(b);
    };

    // Cua so trang: luon co trang dau/cuoi + lan can trang hien tai.
    // 25 trang x 38px khong vua man hinh dien thoai -> chi ~7 o, phan con lai la "...".
    var win = [];
    for (var i = 1; i <= pages; i++) {
      if (i === 1 || i === pages || (i >= page - 1 && i <= page + 1)) win.push(i);
    }

    if (page > 1) add('‹', page - 1, false, 'Previous page');
    var prev = 0;
    win.forEach(function (n) {
      if (prev && n - prev > 1) {
        var gap = document.createElement('span');
        gap.className = 'msc-gap';
        gap.setAttribute('aria-hidden', 'true');
        gap.textContent = '…';
        pager.appendChild(gap);
      }
      add(String(n), n, n === page);
      prev = n;
    });
    if (page < pages) add('›', page + 1, false, 'Next page');
  }

  if (slider) {
    var paint = function () {
      var min = parseInt(slider.min, 10);
      var max = parseInt(slider.max, 10);
      var p = max > min ? (wall() - min) / (max - min) : 1;
      if (readoutV) readoutV.textContent = wall();
      if (fill) fill.style.transform = 'scaleX(' + p + ')';
      if (datum) datum.style.left = p * 100 + '%';
      // So doc can giua tren datum nhu ban thiet ke, chi ghim lai khi cham hai dau
      // de khong tran khoi cot (ban demo khong gap vi gia tri mac dinh nam giua).
      if (readout) {
        var track = readout.parentElement.offsetWidth;
        var half = readout.offsetWidth / 2;
        var x = Math.min(Math.max(p * track, half), track - half);
        readout.style.left = x + 'px';
        readout.style.transform = 'translateX(-50%)';
      }
    };

    slider.addEventListener('input', function () {
      touched = true;
      page = 1;
      paint();
      render();
    });

    // Ghim hai dau phu thuoc be rong that -> tinh lai khi doi kich thuoc cua so.
    paintRule = paint;
    paint();
  }

  var resetWall = root.querySelector('[data-ms-reset-wall]');
  if (resetWall && slider) {
    resetWall.addEventListener('click', function () {
      slider.value = slider.max;
      touched = false;
      page = 1;
      paint();
      render();
      slider.focus();
    });
  }

  buildFitRows();
  render();

  /* ── ngày giao hàng: số học trên lời hứa thật, không phải claim ── */
  var from = root.querySelector('[data-ms-date-from]');
  var to = root.querySelector('[data-ms-date-to]');
  if (from && to) {
    var fmt = function (days) {
      var d = new Date();
      d.setDate(d.getDate() + days);
      return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    };
    var dmin = parseInt(root.dataset.daysMin, 10);
    var dmax = parseInt(root.dataset.daysMax, 10);
    from.textContent = fmt(isNaN(dmin) ? 14 : dmin);
    to.textContent = fmt(isNaN(dmax) ? 42 : dmax);
  }
  }
  initContent();

  /* ── drawer ───────────────────────────────────────────── */
  var drawer = root.querySelector('[data-ms-drawer]');
  var scrim = root.querySelector('[data-ms-scrim]');
  var closeBtn = root.querySelector('[data-ms-close-filters]');

  function setDrawer(open) {
    if (!drawer || !scrim) return;
    // Nút Filters nằm trong rail -> bị thay mỗi lần lọc ajax, phải tìm lại.
    var openBtn = root.querySelector('[data-ms-open-filters]');
    if (open) {
      drawer.hidden = false;
      scrim.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-on');
        scrim.classList.add('is-on');
      });
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    } else {
      drawer.classList.remove('is-on');
      scrim.classList.remove('is-on');
      document.documentElement.style.overflow = '';
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-on')) { drawer.hidden = true; scrim.hidden = true; }
      }, 280);
      if (openBtn) openBtn.focus();
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ms-open-filters]')) setDrawer(true);
  });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) setDrawer(false);
  });

  /* ── "Show n more" trong mỗi facet (nội dung drawer bị thay -> delegate) ── */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ms-more]');
    if (!btn) return;
    var facet = btn.closest('[data-ms-facet]');
    if (!facet) return;
    facet.querySelectorAll('.msc-val-more').forEach(function (li) { li.hidden = false; });
    btn.remove();
  });

  /* ── lọc ajax: tick facet / đổi sort / sang trang -> thay tại chỗ ── */
  var form = root.querySelector('[data-ms-filter-form]');
  var host = root.closest('.shopify-section');
  var sectionId = host ? host.id.replace('shopify-section-', '') : '';
  var ctrl = null;
  var shown = location.search;

  function formUrl(f) {
    var q = new URLSearchParams(new FormData(f)).toString();
    return f.action.split('?')[0] + (q ? '?' + q : '');
  }

  function facetKey(d) {
    var t = d.querySelector('.msc-facet-t');
    return t ? t.textContent : '';
  }

  // Drawer đang mở giữa lúc lọc: giữ facet đang xổ, "show more", ô đang focus, vị trí cuộn.
  // Khoá theo tên facet chứ không theo thứ tự — tắt/bật thước làm facet Width ra/vào.
  function swapForm(next) {
    if (!form || !next) return;
    var open = {};
    var more = {};
    form.querySelectorAll('[data-ms-facet]').forEach(function (d) {
      var k = facetKey(d);
      if (d.open) open[k] = 1;
      if (d.querySelector('.msc-val-more') && !d.querySelector('[data-ms-more]')) more[k] = 1;
    });
    var a = document.activeElement;
    var focusKey = a && form.contains(a) && a.name ? a.name + '\n' + a.value : '';
    var top = form.scrollTop;

    form.innerHTML = next.innerHTML;

    form.querySelectorAll('[data-ms-facet]').forEach(function (d) {
      var k = facetKey(d);
      if (open[k]) d.open = true;
      if (more[k]) {
        d.querySelectorAll('.msc-val-more').forEach(function (li) { li.hidden = false; });
        var b = d.querySelector('[data-ms-more]');
        if (b) b.remove();
      }
    });
    if (focusKey) {
      form.querySelectorAll('input[name]').forEach(function (el) {
        if (el.name + '\n' + el.value === focusKey) el.focus({ preventScroll: true });
      });
    }
    form.scrollTop = top;
  }

  // Overlay (CSS .is-loading) chặn click dồn; spinner nằm giữa drawer nếu đang mở, không thì giữa màn hình.
  var spin = document.createElement('span');
  spin.className = 'msc-spin';
  spin.hidden = true;
  spin.setAttribute('role', 'status');
  spin.setAttribute('aria-label', 'Loading products');

  function busy(on) {
    root.classList.toggle('is-loading', on);
    root.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) (drawer && !drawer.hidden ? drawer : root).appendChild(spin);
    spin.hidden = !on;
  }

  // Trang dang xem qua ?view=<suffix> -> form/Reset dung collection.url tran, phai giu view
  // khong thi URL sau loc (va F5) roi ve template mac dinh.
  function withView(url) {
    var view = new URLSearchParams(location.search).get('view');
    var v = new URL(url, location.href);
    if (view && !v.searchParams.has('view')) v.searchParams.set('view', view);
    return v.toString();
  }

  function load(url, push, scroll) {
    url = withView(url);
    if (!sectionId || !window.fetch) { location.href = url; return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    busy(true);
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sectionId);
    fetch(u.toString(), { signal: ctrl.signal, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ms-coll]');
        if (!next) throw new Error('section missing');
        ['.msc-band', '.msc-rail', '[data-ms-results]'].forEach(function (sel) {
          var a = root.querySelector(sel);
          var b = next.querySelector(sel);
          if (a && b) a.replaceWith(b);
        });
        swapForm(next.querySelector('[data-ms-filter-form]'));
        if (push) history.pushState({ msColl: 1 }, '', url);
        shown = location.search;
        busy(false);
        initContent();
        if (scroll) scrollToGrid();
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = url;
      });
  }

  if (form) {
    // Tick là lọc luôn. Ô giá chỉ bắn "change" khi rời ô / Enter nên không cần debounce.
    form.addEventListener('change', function () { load(formUrl(form), true); });
    // Apply giờ chỉ còn là "đóng drawer" — kết quả đã có sẵn phía sau.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = withView(formUrl(form));
      if (new URL(url).search !== location.search) load(url, true);
      setDrawer(false);
    });
  }

  // Sort nằm trong rail (bị thay) -> delegate. Form drawer cũng bubble lên đây, nên lọc theo closest.
  root.addEventListener('change', function (e) {
    var f = e.target.closest('[data-ms-sortform]');
    if (f) load(formUrl(f), true);
  });

  // Reset trong drawer + pager server (>250 sp).
  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-ms-filter-form] a[href], .msc-pager--server a[href]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    load(link.href, true, !!link.closest('.msc-pager--server'));
  });

  window.addEventListener('popstate', function () {
    if (location.search !== shown) load(location.href, false);
  });
})();
